import React from 'react';
import { FaSpinner } from 'react-icons/fa';

// Small inline spinner for use inside buttons to show an action is in
// progress, e.g. <button disabled={saving}>{saving ? <><Spinner /> Saving...</> : 'Save'}</button>
const Spinner = ({ style }) => <FaSpinner className="spinner-icon" style={style} />;

export default Spinner;
